/* tslint:disable */
/* eslint-disable */
/* @relayHash 9e89eb837bb3a063145cbde034ad9003 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OrderBy = {
    ascending?: boolean | null;
    field: string;
};
export type DelegateFilter = {
    uuid?: string | null;
    ttc_id?: string | null;
    name?: string | null;
    email?: string | null;
    jobTitle?: string | null;
    telephone?: string | null;
    expiringBefore?: string | null;
    allCompleted?: boolean | null;
    secondaryCategoryUUID?: string | null;
    hasActiveCert?: boolean | null;
    hasExpiredCert?: boolean | null;
    hasIncompleteCourse?: boolean | null;
    simulatorCompliant?: boolean | null;
    hasActiveDocument?: boolean | null;
    hasExpiredDocument?: boolean | null;
    hasValidBackgroundCheck?: boolean | null;
    hasExpiredBackgroundCheck?: boolean | null;
};
export type App_DelegatesPage_QueryVariables = {
    offset?: number | null;
    limit?: number | null;
    orderBy?: OrderBy | null;
    filter?: DelegateFilter | null;
};
export type App_DelegatesPage_QueryResponse = {
    readonly delegates: {
        readonly " $fragmentRefs": FragmentRefs<"DelegatesPage_delegates">;
    } | null;
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"DelegatesPage_manager">;
    } | null;
};
export type App_DelegatesPage_Query = {
    readonly response: App_DelegatesPage_QueryResponse;
    readonly variables: App_DelegatesPage_QueryVariables;
};



/*
query App_DelegatesPage_Query(
  $offset: Int
  $limit: Int
  $orderBy: OrderBy
  $filter: DelegateFilter
) {
  delegates(page: {offset: $offset, limit: $limit}, orderBy: $orderBy, filter: $filter) {
    ...DelegatesPage_delegates
  }
  manager {
    ...DelegatesPage_manager
  }
}

fragment DelegatesPage_delegates on DelegatePage {
  edges {
    uuid
    email
    firstName
    lastName
    lastLogin
    createdAt
    myCourses {
      status
    }
    myClassroomCourses {
      status
    }
    nextExpiry
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}

fragment DelegatesPage_manager on Manager {
  company {
    name
    simulatorReportPreviewURL
    simulatorCompliance {
      activeUsers
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "offset",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "limit",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "orderBy",
            "type": "OrderBy",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "DelegateFilter",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        } as any),
        ({
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "orderBy"
        } as any),
        ({
            "kind": "ObjectValue",
            "name": "page",
            "fields": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "offset",
                    "variableName": "offset"
                }
            ]
        } as any)
    ], v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_DelegatesPage_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegates",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "DelegatePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegatesPage_delegates",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegatesPage_manager",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_DelegatesPage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegates",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "DelegatePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Delegate",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "uuid",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastLogin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createdAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "myCourses",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MyCourse",
                                    "plural": true,
                                    "selections": (v2 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "myClassroomCourses",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MyCourse",
                                    "plural": true,
                                    "selections": (v2 /*: any*/)
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "nextExpiry",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "simulatorReportPreviewURL",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "simulatorCompliance",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SimulatorCompliance",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "activeUsers",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_DelegatesPage_Query",
            "id": null,
            "text": "query App_DelegatesPage_Query(\n  $offset: Int\n  $limit: Int\n  $orderBy: OrderBy\n  $filter: DelegateFilter\n) {\n  delegates(page: {offset: $offset, limit: $limit}, orderBy: $orderBy, filter: $filter) {\n    ...DelegatesPage_delegates\n  }\n  manager {\n    ...DelegatesPage_manager\n  }\n}\n\nfragment DelegatesPage_delegates on DelegatePage {\n  edges {\n    uuid\n    email\n    firstName\n    lastName\n    lastLogin\n    createdAt\n    myCourses {\n      status\n    }\n    myClassroomCourses {\n      status\n    }\n    nextExpiry\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n\nfragment DelegatesPage_manager on Manager {\n  company {\n    name\n    simulatorReportPreviewURL\n    simulatorCompliance {\n      activeUsers\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '9f093c01cda6dddc9dd52f2cb853123f';
export default node;
